import {
  addDoc,
  deleteDoc,
  getDocs,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import {
  getCouponRef,
  getCouponsCollectionRef,
} from "../../../firebase/collectionReferences";

// Get All Coupons
export async function getAllCoupons() {
  const couponsRef = getCouponsCollectionRef();
  const snapshot = await getDocs(couponsRef);
  const coupons = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return coupons;
}

// Delete Coupon
export async function deleteCoupon(coupon_id) {
  const couponRef = getCouponRef(coupon_id);
  await deleteDoc(couponRef);
}

// Add Coupon
export async function addCoupon(data) {
  const couponsRef = getCouponsCollectionRef();
  const coupon = await addDoc(couponsRef, {
    ...data,
    createdAt: serverTimestamp(),
  });
  return coupon.id;
}

// Update Coupon
export async function updateCoupon(data) {
  const couponRef = getCouponRef(data.id);
  await updateDoc(couponRef, data);
  return data.id;
}
